export function parseSeconds(s: string | null | undefined): number {
  if (!s) {
    throw Error(`missing value`)
  }

  return parseInt(s, 10)
}
